import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
section {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
}
.nav-wrapper {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
}
section.active {
    margin-top: 10px;
}
nav {
    top: 0px;
    position: -webkit-sticky;
    position: sticky;
    background: #f7f7f7;
  z-index: 1;
}
nav:before {
    content: ' ';
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: #eeeeee;
}
nav:-webkit-scrollbar {
    /** SWIPE STUFF **/
    display: none;
}
div.tabbed nav {
    position: relative;
}
ul {
    padding: 0;
    margin-bottom: 0;
    margin-top: 0;
    position: relative;
    display: flex;
}
ul.mobile {
    display: none;
}
li {
    padding: calc(24px / 2);
    font-size: 16px;
    display: inline-block;
    border-bottom: #4c5a6a solid #4c5a6a;
    margin-right: auto;
}
li.active {
    border-bottom: #4c5a6a solid #4c5a6a;
    background-color: #4c5a6a;
}
li :global(a) {
    text-decoration: none;
    color: #4c5a6a;
}
li.active :global(a) {
    color: #ffffff;
}
@media (max-width: 720px) {
    ul.desktop {
        display: none;
    }
    section {
  padding-left: 4px;
  padding-right: 4px;
  margin: 0 auto;
    }
    .nav-wrapper {
  padding-left: 4px;
  padding-right: 4px;
  margin: 0 auto;
    }
}
@media (max-width: 1080px) {
    ul {
        display: block;
    }
    li {
        margin-right: 0;
    }
}
`;

export default styles;